import axios from "axios";
import { CONFIG } from "./config";

const api = axios.create({
  baseURL: CONFIG.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function submitLead(payload) {
  try {
    const { data } = await api.post("/api/applicants", payload);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;
      throw new Error(`submitLead failed: ${status} ${message}`);
    }
    throw error;
  }
}

export async function sendChatMessage(payload) {
  try {
    const { data } = await api.post("/api/chat", payload);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;
      throw new Error(`sendChatMessage failed: ${status} ${message}`);
    }
    throw error;
  }
}

export async function submitFetusReferral(payload) {
  try {
    const { data } = await api.post("/api/fetus-referrals", payload);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;
      throw new Error(`submitFetusReferral failed: ${status} ${message}`);
    }
    throw error;
  }
}

export async function submitChildReferral(payload) {
  try {
    const { data } = await api.post("/api/child-referrals", payload);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;
      throw new Error(`submitChildReferral failed: ${status} ${message}`);
    }
    throw error;
  }
}
